import { PublicGameReport } from '@pitch-tracker/shared';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import OpponentAttackSummary from '../../components/performanceSummary/OpponentAttackSummary/OpponentAttackSummary';
import PerformanceSummaryCard from '../../components/performanceSummary/PerformanceSummaryCard/PerformanceSummaryCard';
import { performanceSummaryService } from '../../services/performanceSummaryService';
import {
    Body,
    Brand,
    Footer,
    GameSub,
    GameTitle,
    HeaderBar,
    HeaderInner,
    HeaderMeta,
    Page,
    PitcherSectionTitle,
    StateMessage,
} from './styles';

const PublicReport: React.FC = () => {
    const { gameId } = useParams<{ gameId: string }>();
    const [report, setReport] = useState<PublicGameReport | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!gameId) return;
        let cancelled = false;
        setLoading(true);
        performanceSummaryService
            .getPublicReport(gameId)
            .then((r) => {
                if (!cancelled) setReport(r);
            })
            .catch(() => {
                if (!cancelled) setError('Report not available.');
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });
        return () => {
            cancelled = true;
        };
    }, [gameId]);

    const scoreLabel = report?.score ? `${report.score.home}-${report.score.away}` : null;

    return (
        <Page>
            <HeaderBar>
                <HeaderInner>
                    <Brand>Pitch Chart</Brand>
                    {report && (
                        <HeaderMeta>{report.game_date ? `Postgame Report · ${report.game_date}` : 'Postgame Report'}</HeaderMeta>
                    )}
                </HeaderInner>
            </HeaderBar>

            <Body>
                {loading && <StateMessage>Loading report…</StateMessage>}
                {!loading && error && <StateMessage>{error}</StateMessage>}
                {!loading && !error && report && (
                    <>
                        <GameTitle>
                            {report.home_team_name} vs. {report.opponent_name}
                        </GameTitle>
                        <GameSub>{scoreLabel ? `Final ${scoreLabel}` : 'Final'}</GameSub>

                        <OpponentAttackSummary
                            gameId={report.game_id}
                            summary={report.team_offense}
                            myTeamBatterBreakdown={report.my_team_batter_breakdown}
                            readOnly
                        />

                        {report.pitchers.length > 0 && (
                            <>
                                <PitcherSectionTitle>Coaches Summary</PitcherSectionTitle>
                                {report.pitchers.map((p) => (
                                    <PerformanceSummaryCard key={p.id} summary={p} batterBreakdown={report.batter_breakdown} />
                                ))}
                            </>
                        )}

                        <Footer>Generated by Pitch Chart.</Footer>
                    </>
                )}
            </Body>
        </Page>
    );
};

export default PublicReport;
